import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys } from "vue"

const _hoisted_1 = ["onKeydown"]
const _hoisted_2 = { class: "shop-card__content-container" }
const _hoisted_3 = { class: "shop-card__image-container" }
const _hoisted_4 = ["src"]
const _hoisted_5 = { key: 1 }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "shop-card__button-select-text" }

import { computed } from 'vue';
import { getBaseUrl } from '@utils/environmentUtils';
import type { ShopCard } from '@/interfaces/shop-info';
import RoundedButton from '../RoundedButton/RoundedButton.vue';
import ShopContactData from '../ShopContactData/ShopContactData.vue';
import { useTranslations } from '@helper/composables/translations';

interface Props {
	shopList: ShopCard;
	shopSelection: boolean;
	isSelected: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ShopCard',
  props: {
    shopList: {},
    shopSelection: { type: Boolean },
    isSelected: { type: Boolean }
  },
  emits: ['shop-select'],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;
const { translate } = useTranslations();

const props = __props;
const buttonText = computed(() => {
	if (props.shopSelection) {
		return props.isSelected ? 'travelAgency.selected' : 'travelAgency.selection';
	} else {
		return 'travelAgency.info';
	}
});

const imgPath = computed((): string => (props.shopList.image ? getBaseUrl() + props.shopList.image : ''));

const handleShopInteract = () => {
	if (props.shopSelection) {
		emit('shop-select');
	} else {
		window.location.href = props.shopList.uri_detail;
	}
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("a", {
    class: "shop-card",
    onClick: _withModifiers(handleShopInteract, ["stop","prevent"]),
    onKeydown: _withKeys(_withModifiers(handleShopInteract, ["stop","prevent"]), ["enter"])
  }, [
    _createElementVNode("h4", null, _toDisplayString(_ctx.shopList.name), 1 /* TEXT */),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (imgPath.value)
          ? (_openBlock(), _createElementBlock("img", {
              key: 0,
              src: imgPath.value,
              class: "shop-card__image"
            }, null, 8 /* PROPS */, _hoisted_4))
          : (_openBlock(), _createElementBlock("div", _hoisted_5))
      ]),
      _createVNode(ShopContactData, {
        "shop-info": _ctx.shopList,
        class: "shop-card__contact-data"
      }, null, 8 /* PROPS */, ["shop-info"]),
      _createElementVNode("div", {
        class: "shop-card__further-info",
        innerHTML: _ctx.shopList.introtext
      }, null, 8 /* PROPS */, _hoisted_6)
    ]),
    _createCommentVNode("Important: This button is \"fake\". Interaction happens when the wrapping <a> is clicked"),
    _createVNode(RoundedButton, {
      theme: "extra",
      class: _normalizeClass(["shop-card__button", { 'shop-card__button--selected': _ctx.isSelected }]),
      title: _ctx.shopList.name
    }, {
      default: _withCtx(() => [
        _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(translate)(buttonText.value)), 1 /* TEXT */)
      ]),
      _: 1 /* STABLE */
    }, 8 /* PROPS */, ["class", "title"]),
    _createCommentVNode("--------------------------------------------------")
  ], 40 /* PROPS, NEED_HYDRATION */, _hoisted_1))
}
}

})